import type { Translatable } from "app/pages/sales-intelligence/types";

export const INTENT_EMPTY_TOPIC_BANNER_I18N: Record<string, Translatable> = {
    title: {
        key: "si.signals.filters.intent.banner.empty-state.title",
    },
    description: {
        key: "si.signals.filters.intent.banner.empty-state.admin.description",
    },
    descriptionMultiline: {
        key: "si.signals.filters.intent.banner.empty-state.admin.description.multiline",
    },
};
